
<template>
  <div>
    <h1 class="text-[24px] font-bold text-[#111111]">{{ title }}</h1>
  </div>
</template>

<script setup lang="ts">
const title = 'Профиль'
</script>


<style scoped>
h1 {
  color: #2c3e50;
  font-family: Arial, sans-serif;
  text-align: center;
  margin-top: 60px;
}
</style>